export default __webpack_public_path__ + "static/media/640_store05-fr-web.53b04fd8.png";